import { render, staticRenderFns } from "./Normal.vue?vue&type=template&id=ef7afbf6"
import script from "./Normal.vue?vue&type=script&lang=js"
export * from "./Normal.vue?vue&type=script&lang=js"
import style0 from "./Normal.vue?vue&type=style&index=0&id=ef7afbf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports